import { render } from "./VTeam.vue?vue&type=template&id=5f1f9cad"
import script from "./VTeam.vue?vue&type=script&lang=ts"
export * from "./VTeam.vue?vue&type=script&lang=ts"

import "./VTeam.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script